import { render, staticRenderFns } from "./Command.vue?vue&type=template&id=d56fc50e&scoped=true&"
import script from "./Command.vue?vue&type=script&lang=ts&"
export * from "./Command.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d56fc50e",
  null
  
)

export default component.exports